import { KatapultElement, html } from '../../mixins/katapult-element';
import { KatapultWizardTemplate } from './katapult-model-space-wizard-template';

import '../style-modules/paper-table-style';
import './katapult-model-space-pla-import-wizard.js';
import { DefaultStyle } from './katapult-model-editor-style';
import { SharingLink } from '../sharing-link/sharing-link.js';
import '../katapult-elements/katapult-button.js';

class KatapultRemoteModelSpaceSetupWizard extends KatapultWizardTemplate {
  static get template() {
    return html`
      ${DefaultStyle}
      <style include="paper-dialog-style paper-table-style">
        [hidden] {
          display: none !important;
        }
      </style>
      <wizard-page name="enterSharingCode" show-go-back on-go-back="goBack" compact$="[[compact]]">
        <div class="prompt">Please enter a sharing code below:</div>
        <paper-table white outline rounded>
          <paper-row input expand>
            <paper-cell>
              <paper-input id="sharingCodeInput" label="Sharing Code" value="{{sharingCode}}" no-label-float></paper-input>
            </paper-cell>
          </paper-row>
        </paper-table>
        <div class="buttons">
          <katapult-button id="checkTokenButton" color="var(--secondary-color)" callback="_getSharingLinkDetails" disabled
            >Continue</katapult-button
          >
        </div>
      </wizard-page>
      <wizard-page name="confirmSharingLink" show-go-back on-go-back="goToPreviousStep" compact$="[[compact]]">
        <div style="text-align: center;">
          <p>
            You are about to add the shared <strong>[[sharingLink.sender.company]]</strong> model<span
              hidden$="[[equal(sharingLink.sender.server_id, config.appName)]]"
            >
              from the <strong>[[sharingLink.sender.server]]</strong> server</span
            >
            to your list of models.
          </p>
          <p>Would you like to continue?</p>
        </div>
        <div class="buttons">
          <katapult-button id="continueButton" color="var(--secondary-color)" callback="finished">Continue</katapult-button>
        </div>
      </wizard-page>
    `;
  }

  static get properties() {
    return {
      compact: {
        type: Boolean,
        value: false
      },
      sharingCode: {
        type: String,
        observer: '_sharingCodeChanged'
      },
      sharingCodeValid: {
        type: Boolean,
        value: false
      },
      steps: {
        type: Array,
        value: ['enterSharingCode', 'confirmSharingLink']
      }
    };
  }

  constructor() {
    super();
    this.config = window.config;
    this.equal = (a, b) => a === b;
  }

  ready() {
    super.ready();

    this.anim.register(this.$.continueButton, {
      observer: 'sharingCodeValid',
      rules: [
        {
          if: true,
          style: { $invisible: true, transform: 'translateY(12px)' }
        },
        {
          if: (sharingCodeValid) => sharingCodeValid,
          style: { $invisible: false, transform: 'none' }
        }
      ]
    });

    setTimeout(() => {
      this.begin();
    }, 1000);
  }

  begin() {
    this.goToStep('enterSharingCode');
    setTimeout(() => this.$.sharingCodeInput.focus(), 1000);
  }

  finished() {
    this.dispatchEvent(new CustomEvent('finished', { detail: { token: this.sharingLink.token } }));
    setTimeout(() => this.reset(), 300);
  }

  goBack() {
    this.dispatchEvent(new CustomEvent('go-back'));
  }

  reset() {
    this.goToStep('enterSharingCode');
    this.$.sharingCodeInput.value = '';
  }

  _sharingCodeChanged() {
    const token = this.sharingCode?.trim();
    this.sharingCodeValid = SharingLink.tokenFormatValid(token);
    const input = this.$.sharingCodeInput;
    input.invalid = token.length && !this.sharingCodeValid;
    input.errorMessage = input.invalid ? 'Must be a 10 digit code consisting of numbers and letters' : null;
    this.$.checkTokenButton.disabled = !this.sharingCodeValid;
  }

  async _getSharingLinkDetails() {
    this.sharingLink = await SharingLink.serverAction({ action: 'get', token: this.sharingCode }).then((x) => x.sharingLink);
    if (!this.sharingLink) return;
    // Make sure the model isn't already in the list
    if (
      this.config.appName == this.sharingLink.sender.server_id &&
      this.modelSpaceChooserOptions.some((x) => x.$key == this.sharingLink.sender.company_id)
    ) {
      this.$.sharingCodeInput.invalid = true;
      this.$.sharingCodeInput.errorMessage = `${this.sharingLink.sender.company} is already in your list of models`;
    } else {
      this.goToStep('confirmSharingLink');
    }
  }
}

customElements.define('katapult-remote-model-space-setup-wizard', KatapultRemoteModelSpaceSetupWizard);
